<style scoped>
  h1 {
    z-index: 0;
    position: absolute;
  }

  .layout {
    background: #f5f7f9;
    position: relative;
  }

  .layout-logo {
    text-align: center;
  }

  .layout-logo img {
    width: 60%;
    margin: 20px;
  }

  .layout-copy {
    text-align: center;
    padding: 10px 0 20px;
    color: #9ea7b4;
  }

  .layout-menu-left {
    background: #464c5b;
    position: fixed;
    top: 0;
    bottom: 0;
  }
</style>
<template>
  <div class="layout">
    <h1>一稿过</h1>
    <Row type="flex" class="layout-menu-row">
      <i-col span="3" class="layout-menu-left">
        <div class="layout-logo">
          <img src="../static/logo.png">
        </div>
        <Menu theme="dark" width="auto" :active-name="activeName" :open-names="['1']">
          <div class="layout-logo-left"></div>
          <Submenu name="1">
            <template slot="title">
              <Icon type="ios-navigate"></Icon>
              导航一
            </template>
            <router-link v-for='(item,index) in navList' key='index' :to='`#${item.title}`'>
              <Menu-item @click.native="scroll(item.title)" :name='item.title'>{{item.title}}</Menu-item>
            </router-link>
          </Submenu>
        </Menu>
      </i-col>
      <i-col span="21" offset="3">
        <first-page></first-page>
        <div class="layout-copy">
          2016-2017 &copy; Roger
        </div>
      </i-col>
    </Row>
  </div>
</template>
<script>
  import First from './page/first'
  import navList from './data/_list.json'
  export default {
    components: {
      'first-page': First
    },
    mounted() {
      let hashName = decodeURI(this.$route.hash && this.$route.hash.replace('#', ''))
      if (hashName.length == 4) {
        this.$set(this.$data, 'activeName', hashName)
      }
    },
    data() {
      return {
        navList,
        activeName: '灵感采集'
      }
    },
    methods: {
      scroll(id) {
        var win = window;
        var to = document.querySelector(`#${id}`).offsetTop
        var scrollTop = 0;
        var speed;
        window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

        if (document.documentElement && document.documentElement.scrollTop) {
          scrollTop = document.documentElement.scrollTop;
        } else if (document.body) {
          scrollTop = document.body.scrollTop;
        }

        if (scrollTop === to) { return }

        speed = (to - scrollTop) / 20;

        function move() {
          scrollTop += speed;
          window.scrollTo(0, scrollTop);
          if (speed > 0 && scrollTop + speed <= to + 1 || speed < 0 && scrollTop + speed >= to - 1) {
            requestAnimationFrame(move);
          } else {
            window.scrollTo(0, to);
          }
        }

        requestAnimationFrame(move);
      }
    }
  }

</script>


// WEBPACK FOOTER //
// App.vue?514fd2d5